import QueueTransformer from '../transformers/QueueTransformer';

const validateStatus = (response) => {
  if (response.status < 200 || response.status >= 300) {
    console.error(response);
    throw new Error(`Got error-status ${response.status} while communicating with task queue API.`);
  }

  return response;
};

class TaskQueueService {
  constructor({protocol, hostname, port, pathname}) {
    this.transformer = new QueueTransformer();
    this.baseUrl = `${protocol}://${hostname}:${port}${pathname}`;
  }

  getQueue(offset, limit, returnWithTotalCount) {
    const url = this.baseUrl + ((offset || limit) ? `queue?offset=${offset}&limit=${limit}` : 'queue');
    return fetch(url).then(
      validateStatus
    ).then((response) => {
      return Promise.all([response.json(), response.headers]);
    }).then(([body, headers]) => {
      const bodyTransformed = body.map(this.transformer.apiToInternal.bind(this.transformer));

      if (returnWithTotalCount) {
        return [bodyTransformed, (headers.has('X-total-count') ? parseInt(headers.get('X-total-count'), 10) : null)];
      }

      return bodyTransformed;
    });
  }

  getTasks() {
    const url = `${this.baseUrl}tasks`;
    return fetch(url).then(
      validateStatus
    ).then((response) => response.json());
  }

  queueTask(taskId, params) {
    const url = `${this.baseUrl}queue`;
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        taskId: taskId,
        params: params
      })
    }).then(
      validateStatus
    ).then((response) => {
      return response.json();
    }).then((body) => {
      return this.transformer.apiToInternal(body);
    });
  }
}

export default TaskQueueService;
